import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { InstantLearning } from 'src/types/instant-learning';

export const visibleCardIds = atom<string[]>([]);

export const cardOrder = atom<Record<string, number>>({});

// autoplayed-second counter to prevent user from fast-forwarding
export const autoPlayedSeconds = atom<number>(0);

export const currentPlayedSeconds = atom<number>(0);

export const autoPlayedCard = atom<InstantLearning['learning'] | null>(null);

export const autoPlayedItem = atom<InstantLearning | null>(null);

export type SubtitleCueType = {
  endTime: number;
  startTime: number;
  text: string;
};

export type CurrentSubtitleTrackType = {
  activeCues: SubtitleCueType[] | null;
  cues: SubtitleCueType[] | null;
  kind: string;
  label: string;
  language: string;
  mode: 'disabled' | 'showing';
};

export type CaptionLanguagesType = {
  default: boolean;
  src: string;
  srcLang: string;
};

export const allLanguages = atomWithReset<CaptionLanguagesType[]>([
  {
    default: false,
    src: '',
    srcLang: '',
  },
]);

export const trackLang = atomWithReset<CaptionLanguagesType>({
  default: false,
  src: '',
  srcLang: '',
});

export const videoSpeed = atomWithReset<number>(1.0);

export const currentPipModeUrl = atom<string | null>(null);

export const pipModeLearningId = atom<string | null>(null);

export const isPipModeVideoPlaying = atom<boolean>(false);

export const currentPipModeDuration = atom<number | null>(null);

export const isPipModeVideoEnded = atom(false);

export const isPipModeActive = atom(false, (get, set, newValue) => {
  set(isPipModeActive, newValue);


  // reset dependent atoms if PIP mode is deactivated
  if (!newValue) {
    set(currentPipModeUrl, null);
    set(isPipModeVideoPlaying, false);
    set(currentPipModeDuration, null);
  }
});

export const pipModePlayed = atom<number>(0);
